import React, { useEffect, useState, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCashRegister, faClock, faMoneyBillWave, faExchangeAlt, faUsers, faSync, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import baseURL from '../../url';
import moneda from '../../moneda';
import { usePlan } from '../../PlanContext';
import './CajasAbiertas.css';

export default function CajasAbiertas() {
    const { isPlus } = usePlan();
    const [cajas, setCajas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [actualizado, setActualizado] = useState(null);

    const cargar = useCallback(() => {
        fetch(`${baseURL}/cajasAbiertasGet.php`)
            .then(r => r.json())
            .then(d => {
                setCajas(d.cajas || []);
                setActualizado(new Date());
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, []);

    useEffect(() => {
        cargar();
        const interval = setInterval(cargar, 60000);
        return () => clearInterval(interval);
    }, [cargar]);

    const fmt = (n) => Number(n || 0).toLocaleString('es-AR');

    const formatTiempo = (segs) => {
        const horas = Math.floor(segs / 3600);
        const minutos = Math.floor((segs % 3600) / 60);
        return `${horas}h ${minutos}m`;
    };

    return (
        <div className='caContainer'>
            <div className='caHeader'>
                <h3>
                    <FontAwesomeIcon icon={faCashRegister} /> {isPlus ? 'Cajas abiertas ahora' : 'Caja activa'}
                </h3>
                <div className='caHeaderRight'>
                    {actualizado && (
                        <span className='caActualizado'>
                            Actualizado {actualizado.toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
                        </span>
                    )}
                    <button className='caRefresh' onClick={cargar} title='Refrescar'>
                        <FontAwesomeIcon icon={faSync} />
                    </button>
                </div>
            </div>

            {loading ? (
                <p className='caVacio'>Cargando...</p>
            ) : cajas.length === 0 ? (
                <div className='caSinCajas'>
                    <FontAwesomeIcon icon={faCheckCircle} className='caSinCajasIcon' />
                    <p>{isPlus ? 'No hay cajas abiertas en este momento' : 'No hay caja abierta. Esperando que un trabajador la abra.'}</p>
                </div>
            ) : (
                <div className='caGrid'>
                    {cajas.map(c => (
                        <div key={c.idCaja} className='caCard'>
                            <div className='caCardHeader'>
                                <div>
                                    <div className='caCardLabel'>Caja #{c.idCaja}</div>
                                    <div className='caCardTrabajador'>Abrió: {c.nombreTrabajador || '—'}</div>
                                </div>
                                <div className='caCardTiempo'>
                                    <FontAwesomeIcon icon={faClock} /> {formatTiempo(c.segundosAbierta)}
                                </div>
                            </div>

                            {c.nombreSucursal && (
                                <div className='caCardSucursal'>📍 {c.nombreSucursal}</div>
                            )}

                            <div className='caCardStats'>
                                <div className='caStat'>
                                    <span className='caStatLabel'>Inicial</span>
                                    <span className='caStatValor'>{moneda} {fmt(c.montoInicial)}</span>
                                </div>
                                <div className='caStat caStatEfectivo'>
                                    <FontAwesomeIcon icon={faMoneyBillWave} />
                                    <span className='caStatLabel'>Efectivo</span>
                                    <span className='caStatValor'>{moneda} {fmt(c.ventasEfectivo)}</span>
                                </div>
                                <div className='caStat caStatTransf'>
                                    <FontAwesomeIcon icon={faExchangeAlt} />
                                    <span className='caStatLabel'>Transferencia</span>
                                    <span className='caStatValor'>{moneda} {fmt(c.ventasTransferencia)}</span>
                                </div>
                                <div className='caStat'>
                                    <span className='caStatLabel'>Pedidos</span>
                                    <span className='caStatValor'>{c.totalPedidos}</span>
                                </div>
                            </div>

                            <div className='caCardTotal'>
                                <span>Esperado en caja:</span>
                                <strong>{moneda} {fmt(Number(c.montoInicial) + Number(c.ventasEfectivo))}</strong>
                            </div>

                            {c.ventasPorTrabajador && c.ventasPorTrabajador.length > 0 && (
                                <div className='caCardTrabajadores'>
                                    <div className='caCardTrabajadoresHeader'>
                                        <FontAwesomeIcon icon={faUsers} /> Ventas por trabajador
                                    </div>
                                    {c.ventasPorTrabajador.map((t, i) => (
                                        <div key={i} className='caTrabajadorRow'>
                                            <span className='caTrabajadorNombre'>{t.nombre || '—'}</span>
                                            <span className='caTrabajadorEfectivo'>{moneda} {fmt(t.efectivo)}</span>
                                            <span className='caTrabajadorTransf'>{moneda} {fmt(t.transferencia)}</span>
                                            <span className='caTrabajadorPedidos'>{t.totalPedidos} ped.</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
